var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"terms-and-conditions"},[_c('TitleBreadcrumb'),_c('div',{staticClass:"content-base container",domProps:{"innerHTML":_vm._s(_vm.termsAndConditions)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }